import { useAuthStore } from '../store/auth'
import { useAddFlowStore } from '../store/addFlow'

/**
 * Secure image upload for the "Add by photo" flow. Posts the file to the Create2Stay photo
 * receiver with the consumer's access token as a Bearer credential, and returns the hosted
 * image URL. Uses the same upload identity as the phone listener.
 *
 * Per the service contract: multipart form field `file`, alias `receiverId=tradein`, and do NOT
 * set Content-Type manually (the browser sets the multipart boundary).
 */
const UPLOAD_URL = 'https://services3.create2stay.com/photoreceiver/upload?receiverId=tradein'

export async function uploadPhoto(file: File): Promise<string> {
  const token = useAuthStore.getState().token
  if (!token) throw new Error('Not authenticated — cannot upload a photo.')
  const photoIdent = useAddFlowStore.getState().photoIdent
  if (!photoIdent) throw new Error('No active photo upload session.')

  const formData = new FormData()
  formData.append('file', file)

  const url = new URL(UPLOAD_URL)
  url.searchParams.set('photoIdent', photoIdent)
  const res = await fetch(url.toString(), {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  })
  if (!res.ok) throw new Error(`Upload failed (${res.status}).`)

  const result = (await res.json()) as { url: string }
  return result.url
}
